import { render, staticRenderFns } from "./EmployeeEmploymentPeriodEdit.vue?vue&type=template&id=5127ee6b&"
import script from "./EmployeeEmploymentPeriodEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeEmploymentPeriodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QToolbar,QToolbarTitle,QCardSection,QCardActions,QBtn,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QToolbar,QToolbarTitle,QCardSection,QCardActions,QBtn,QInnerLoading,QSpinnerGears}, component.options.components || {})
